import { BlurEvent } from "@mcleod/components";
import {
    AutogenLayoutCustomerHistoryReport
} from "./autogen/AutogenLayoutCustomerHistoryReport";

export class CustomerHistoryReport extends AutogenLayoutCustomerHistoryReport {
    _min_year = 1950;
    _max_year = new Date().getFullYear();
    _year_validation_warning = `Enter a year between ${this._min_year} and ${this._max_year}`;

    override onLoad(): void | Promise<void> {
        // Initialize form defaults
        const currentYear = new Date().getFullYear();
        this.textboxFirstYearComparison.text = currentYear.toString();
        this.textboxSecondYearComparison.text = (currentYear - 1).toString();
        this.textboxGroupBy.selectedItem = this.textboxGroupBy.items[0];
    }

    isValidYear = (year: number) => year >= this._min_year && year <= this._max_year;

    private validateFirstYear(event: BlurEvent, shouldFocus: boolean = false): boolean {
        const firstYear = Number(this.textboxFirstYearComparison.text);

        if (!this.isValidYear(firstYear)) {
            this.textboxFirstYearComparison.validationWarning = this._year_validation_warning;
            if (shouldFocus) {
                this.textboxFirstYearComparison.focus();
            }
            return false;
        }
        return true;
    }

    private validateSecondYear(event: BlurEvent, shouldFocus: boolean = false): boolean {
        const secondYear = Number(this.textboxSecondYearComparison.text);

        if (!this.isValidYear(secondYear)) {
            this.textboxSecondYearComparison.validationWarning = this._year_validation_warning;
            if (shouldFocus) {
                this.textboxSecondYearComparison.focus();
            }
            return false;
        }
        return true;
    }

    private validateYears(event: BlurEvent, shouldFocus: boolean = false): boolean {
        return !this.validateFirstYear(null, shouldFocus) ? false : this.validateSecondYear(null, shouldFocus);
    }
}
